import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { APIS, INSPECTION_RESULTS } from 'app/common/constants';
import { AlertService } from 'app/core/services/alert.service';
import { HttpService } from 'app/core/services/http.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from '../../../../environments/environment';
import { getAQL, getDefectCodes } from 'qc-shared/lib/static-data';

@Component({
  selector: 'app-client-inspection-details',
  templateUrl: './client-inspection-details.component.html',
  styleUrls: ['./client-inspection-details.component.css','../client-page/client-page.component.css']
})
export class ClientInspectionDetailsComponent implements OnInit {

  inspectionData;
  docDefinition;
  pdf;
  inspectionForm: FormGroup;
  visible;
  isAdmin;
  selectedConsoleCenter
  startDate;
  consoleCenters;
  quantityRemoved;
  allCodes = [];
  defectInfo;
  minMaxQty = [];
  aqlReports = [];
  currentCodeTitle;
  defectCodes;
  codes = [];
  inspectionID;
  pdfDefectPhotos;
  qcID;
  inspector;
  results = INSPECTION_RESULTS;
  defectsCount = { critical: 0, major: 0, minor: 0};
  sizeChartUrl;
  defectImages = [];
  fullProductImage
  defectPics = [];
  constructor(private router: Router, private alertService: AlertService, private http: HttpClient,
              private route: ActivatedRoute, private httpService: HttpService, private fb: FormBuilder) { }

  ngOnInit() {
    this.route.paramMap.subscribe((res: any) => {
      this.inspectionID = res?.params?.id;
      this.qcID = res?.params?.qcid;
    })
    this.httpService.getDataWithCache(APIS.CONSOLE_CENTERS).subscribe(res => {
      this.consoleCenters = res.data;
    });
    this.httpService.getData(APIS.INSPECTION_DETAILS,{qcdata_id:this.qcID}).subscribe(async (res)=>{
      this.defectInfo=res?.data?.defectsDetail;
      // this.defectInfo[1]=this.defectInfo[0];
      // this.defectInfo[0].Photo="https://28oneassetstore.blob.core.windows.net/assets/Inspections/IST/INSPECTIONS/2021.09/2021.09.03/W1010650A/W1010650A Compliance 1027633_1 Ctn5 (08.42).jpg"
      // this.defectInfo[1].Photo="https://28oneassetstore.blob.core.windows.net/assets/Inspections/IST/INSPECTIONS/2021.09/2021.09.03/W1010650A/W1010650A Compliance 1027633_1 Ctn5 (08.42).jpg"
      this.defectImages = this.defectInfo.filter((obj) => {
        if (obj.Critical) {
          this.defectsCount.critical = this.defectsCount.critical+obj?.Critical;
        }
        if (obj.Major) {
          this.defectsCount.major = this.defectsCount.major+obj?.Major;
        }
        if (obj.Minor) {
          this.defectsCount.minor = this.defectsCount.minor+obj?.Minor;
        }
        return obj?.image_URL;
      }).map(obj => {
        return {...obj, severity: obj.Major ? 'Major' : obj.Minor ? 'Minor' : obj.Critical ? 'Critical' : null};
      });

      this.defectPics = this.defectImages.filter((obj) => { return obj.image_URL; });
      this.sizeChartUrl = res?.data?.size_chart_url;
      this.inspectionData = res?.data?.inspectionDetail;
      this.quantityRemoved = this.inspectionData?.removed_quantity;
      this.inspector = this.inspectionData?.inspector;
      this.selectedConsoleCenter = this.inspectionData?.UDC_id;
      this.startDate = this.inspectionData?.inspection_date;
      if (this.defectPics.length > 0) {
        this.pdfDefectPhotos = await this.generateDefectPhotosObj();
        this.fullProductImage = await this.generateFullProductImage();
      }
      this.initForm();
    });
  }

  updateResult(result) {
    this.httpService.putData(APIS.UPDATE_AQL_INSPECTION,{result:result,qcdata_id:this.qcID}).subscribe((res)=>{
      this.httpService.getData(APIS.INSPECTION_DETAILS,{qcdata_id:this.qcID}).subscribe(async (res)=>{
        this.inspectionData = res?.data?.inspectionDetail;
      });
    });
  }

  viewSizeChart() {
    if (this.sizeChartUrl) {
      // this.downloadSizeChart()
      // const url = this.router.serializeUrl(
      //   this.router.createUrlTree([`/spreadsheet/${this.qcID}`])
      // );
      window.open(this.sizeChartUrl);
    } else {
      this.alertService.errorToast("Completed Size Chart cannot be found");
    }
  }

  downloadPDF(url): any {
    const options = { responseType: 'blob' as 'json' };
    return this.http.get(url, options).pipe(map((res:any) => {
      return new Blob([res.blob()], { type: 'application/pdf' });
    }));
  }

  initForm() {
    this.inspectionForm = this.fb.group({
      consoleCenter: [this.inspectionData.UDC_id],
      inspectionDate: [this.inspectionData.inspection_date],
      result: [this.inspectionData?.result],
      supplier: [this.inspectionData?.supplier_name],
      styleName: [this.inspectionData?.style_name],
      styleCode: [this.inspectionData.style_code],
      color: [this.inspectionData?.colour],
      pos: [this.inspectionData?.PO_Nos],
      orderSize: [this.inspectionData?.Order_Size],
      season: [this.inspectionData?.season_code],
      submission: [this.inspectionData.inspection_number],
      inspLevel: [this.inspectionData.sample_level],
      sampleQty: [this.inspectionData?.inspection_quantity],
      minDefects: [`<= ${this.inspectionData?.allowed_defects_min || 0}`],
      majDefects: [`<= ${this.inspectionData?.allowed_defects_maj || 0}`],
      criticalDefects: [`<= ${this.inspectionData?.allowed_defects_critical ||0}`],
    });
  }

  async generateDefectPhotosObj() {
    if (this.defectPics.length > 0) {
      return  {
        style: 'tableExample',
        table: {
          widths: 'auto',
          body: [
            ...await Promise.all(this.defectPics.map(async (obj) => {
              return [{
                image:await this.getBase64ImageFromURL(obj?.image_URL),
                margin: 0,
                fit: [400, 600],
                pageBreak: 'before',
                alignment: 'left',}];
              })
            )
          ]
        }
      }
    }
    return null;
  }

  async generateFullProductImage() {
    if (this.inspectionData.full_product_image_url) {
      return {
        style: 'tableExample',
        border: 0,
        table: {
          body: [
            [{
              image: await this.getRotatedBase64ImageFromURL(this.inspectionData?.full_product_image_url),
              width: 500,
              style: 'header',
            }],
            [{
              text: 'Full Product Image',
              fontSize: 18,
              bold: true,
              fillColor: '#444',
              color: 'white',
            }],
          ]
        }
      }
    }
    return null
  }

  async generateHeader() {
    return [
      {
        margin: [40,10,40,0],
        columns: [
          {
            text: 'AQL Inspection Report',
            alignment: 'center',
            style: 'header',
          },
          {
            image: await this.getBase64ImageFromURL('assets/icons/qc_icon.png'),
            width: 60,
            alignment: 'right',
            style: 'header',
          }
        ],
      },
      {
        margin: [40,0,40,0],
        style: 'tableExample',
        table: {
          widths: ['auto','auto', 'auto', 'auto',15,15,15,15,15,15,15,15,'auto',15,15,15,15,15,15],
          headerRows: 3,
          headerColumns: 19,
          body: [
            [
              { text: 'Supplier', bold: true },
              { text: this.inspectionData?.supplier_name || '', colSpan: 2 },
              {},
              { text: 'Style Name', colSpan: 3, bold: true },
              {},{},
              { text: this.inspectionData?.style_name || '', colSpan: 5 },
              {},{},{},{},
              { text: 'Style Code', bold: true, colSpan: 2 },
              {},
              { text: this.inspectionData?.style_code || '', colSpan: 6 },
              {},{},{},{},{}
            ],
            [
              { text: 'Colour', bold: true },
              { text: this.inspectionData?.colour || '', colSpan: 2 },
              {},
              { text: "P/O No’s", colSpan: 3, bold: true },
              {},{},
              { text: this.inspectionData.PO_Nos || '', colSpan: 5 },
              {},{},{},{},
              { text: 'Order Size', bold: true, colSpan: 2 },
              {},
              { text: this.inspectionData.Order_Size || '', colSpan: 6 },
              {},{},{},{}
            ],
            [
              { text: 'Season', bold: true },
              { text: this.inspectionData.Season || '',},
              { text: "Submission", bold: true },
              '1st', { text: this.inspectionData.submission1 },
              '2nd', { text: this.inspectionData.submission2 },
              '3rd', { text: this.inspectionData.submission3 },
              '4th', { text: this.inspectionData.submission4 },
              { text: 'Insp. Level', bold: true, colSpan: 2 },
              {},
              { text: '1' }, { text: this.inspectionData?.inspection_level1 },
              { text: '2' }, { text: this.inspectionData?.inspection_level2 },
              { text: '3' }, { text: this.inspectionData?.inspection_level3 }
            ]
          ]
        }
      },
    ];
  }

  filterReportData(action) {
    this.allCodes = [];
    getAQL(environment.dataName).forEach(level => {
      let arr = [];
      let findIndex = this.minMaxQty.findIndex((res)=>{ return res?.qtyMin == level?.qty_min});
      if (findIndex == -1) {
        arr.push(level);
        this.aqlReports.push(arr);
        this.minMaxQty.push({qtyMin: level?.qty_min, qtyMax: level?.qty_max});
      } else {
        this.aqlReports[findIndex].push(level);
      }
    });


    // console.log(this.aqlReports)
    // this.defectCodes=res?.data.defectCodes;
    this.defectCodes = getDefectCodes(environment.dataName);
    this.defectCodes.forEach((defect) => {
      if(this.currentCodeTitle != defect?.defect_type) {
        this.codes.push({...defect, isTitle: true});
      }
      this.currentCodeTitle = defect?.defect_type;
      this.codes.push(defect);
    });
    this.defectCodes = this.codes;
    this.defectCodes = this.splitToChunks(this.defectCodes, 3);
    // let allCodes=[];
    // this.defectCodes=this.defectCodes?.reduce((rows, key, index) => (index % 3 == 0 ? rows.push([key]): rows[rows.length-1].push(key)) && rows, []);
    this.defectCodes[0].forEach((element,index) => {
      let row = [];
      row.push(this.defectCodes[0][index]);
      row.push(this.defectCodes[1][index]);
      row.push(this.defectCodes[2][index]);
      this.allCodes.push(row);
    });
    // console.log(this.allCodes);
    // console.log("defect codes=======>",this.defectCodes)
    this.generatePDF(action);
  // })
  }

  viewReport(action) {
    Swal.fire('Please wait');
    Swal.showLoading();
    // this.modalService.open(InspectionReportComponent)
    this.filterReportData(action);
  }

  downloadSizeChart(fileurl=this.sizeChartUrl) {
    if (this.sizeChartUrl) {
      var link = document.createElement('a');
      link.href = fileurl;
      // link.download = `Size Chart ${this.inspectionData?.style_code} ${this.inspectionData?.UDC_id} ${this.inspectionData?.colour_code} ${this.inspectionData?.colour} ${String(this.inspectionData?.Season)} (${this.inspectionData?.inspection_date.replace('-','.')})`;
      link.download = fileurl.substring(fileurl.lastIndexOf('/')+1);
      link.click();
    } else {
      this.alertService.errorToast("Completed Size Chart cannot be found");
    }
  }

  selecteConsoleCenter(event) {
    this.selectedConsoleCenter = event.target.value;
  }
  selectResult(event){
    this.inspectionForm.controls.result.setValue(event?.target?.value);
  }

  async generatePDF(action = 'open') {
    this.docDefinition = {
      info: {
        title: `Inspection Report ${this.inspectionData?.style_code} ${this.inspectionData?.UDC_id} ${this.inspectionData?.colour_code} ${this.inspectionData?.colour} ${this.inspectionData?.Season}(${this.inspectionData?.inspection_date?.replaceAll('-','.')})`,
      },
      pageMargins: [40, 120, 40, 40],
      header: await function() {
        return this.generateHeader();
      }.bind(this)(),
      content: [
        {
          style: 'tableExample',
          table: {
            widths: ['auto', 5, 24,19,16,16,5,24,19,16,16,5,24,19,16,16,5,'auto','auto'],
            headerRows: 1,
            headerColumns: 19,
            body: [
              [
                {
                  text: 'Sample Quantity - Maximum Allowable Defects',
                  colSpan: 19,
                  bold: true,
                  alignment: 'center',
                  fillColor: '#737b84',
                  color: '#f7f9f9',
                },
                {},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}
              ],
              [
                { text: 'Order Size @Colourway Level', bold: true },
                {
                  image: this.writeRotatedText('Level 1 Inspection'),
                  bold: true,
                  rowSpan: 7,
                  width: 30,
                },
                { text: 'Sample Quantity', bold: true },
                { text: 'Critical' },
                { text: 'Major' },
                { text: 'Minor' },
                {
                  image: this.writeRotatedText('Level 2 Inspection'),
                  bold: true,
                  rowSpan: 7,
                  fillcolor: '#444',
                  width: 30,
                },
                { text: 'Sample Quantity', bold: true },
                { text: 'Critical' },
                { text: 'Major' },
                { text: 'Minor' },
                {
                  image: this.writeRotatedText('Level 3 Inspection'),
                  bold: true,
                  rowSpan: 7,
                  fillcolor: '#444',
                  width: 30,
                },
                { text: 'Sample Quantity' },
                { text: 'Critical' },
                { text: 'Major' },
                { text: 'Minor' },
                {
                  image: this.writeRotatedText("Qty's to measure"),
                  bold: true,
                  rowSpan: 7,
                  fillcolor: '#444',
                  width: 30,
                },
                { text: 'Sample Quantity' },
                { text: 'Quantity to measure' }
              ],
              ...this.aqlReports.map((obj) => {
                return [
                  {text:`${obj[0]?.qty_min}${String(obj[0]?.qty_max)?.length>4?'+':('-'+obj[0]?.qty_max)}`, bold:true},{},
                  `${obj[0]?.sample_qty}`,`${obj[0]?.critical}`,`≤${obj[0]?.major}`,`≤${obj[0]?.minor}`,{},
                  `${obj[1]?.sample_qty}`,`${obj[1]?.critical}`,`≤${obj[1]?.major}`,`≤${obj[1]?.minor}`,{},
                  `${obj[2]?.sample_qty}`,`${obj[2]?.critical}`,`≤${obj[2]?.major}`,`≤${obj[2]?.minor}`,{},
                  {text:`${(obj[0]?.qty_to_measure)?(obj[0]?.sample_qty):''}${(obj[0]?.sample_qty)==32?'+':''}`},
                  {text:obj[0]?.qty_to_measure}];
              })
            ]
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return (rowIndex % 2 === 0 && columnIndex!==1 && columnIndex!==6&& columnIndex!==11 && columnIndex!==16) ? '#ECECEB' : null;
            }
          }
        },
        { text: '', style: 'sectionHeader' },
        {
          style: 'defectTable',
          table: {
            heights: 'auto',
            widths: ['5%','28%', '5%', '28%','5%','29%'],
            headerRows: 2,
            headerColumns: 6,
            body: [
              [
                {
                  text: 'Defect Codes',
                  colSpan: 6,
                  bold: true,
                  alignment: 'center',
                  fillColor: '#737b84',
                  color: '#f7f9f9',
                },
                {},{},{},{},{}
              ],
              ...this.allCodes.map((defect,i) => {
                return [
                  {text:`${defect[0]?.isTitle?defect[0]?.defect_type:defect[0]?.defect_code}`,style:defect[0]?.isTitle?'defectTitle':null},
                  {text:`${defect[0]?.isTitle?defect[0]?.defect_type_desc_ENG.split(':')[1]:defect[0]?.defect_code_desc_ENG}`,style:defect[0]?.isTitle?'defectTitle':null},
                  {text:`${defect[1]?.isTitle?defect[1]?.defect_type:defect[1]?.defect_code}`,style:defect[1]?.isTitle?'defectTitle':null},
                  {text:`${defect[1]?.isTitle?defect[1]?.defect_type_desc_ENG.split(':')[1]:defect[1]?.defect_code_desc_ENG}`,style:defect[1].isTitle?'defectTitle':null},
                  {text:`${defect[2]?.isTitle?defect[2]?.defect_type:defect[2]?.defect_code || ''}`,style:defect[2]?.isTitle?'defectTitle':null},
                  {text:`${defect[2]?.isTitle?defect[2]?.defect_type_desc_ENG.split(':')[1]:(defect[2]?.defect_code_desc_ENG ||'')}`,style:defect[2]?.isTitle?'defectTitle':null}];
              })
            ]
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return (rowIndex % 2 === 0) ? '#ECECEB' : null;
            }
          }
        },
        { text: '', style: 'sectionHeader' },
        {
          style: 'tableExample',
          table: {
            widths: ['5%','55%','10%','10%','10%','10%'],
            headerRows: 2,
            headerColumns: 6,
            body: [
              [
                {
                  text: 'Defects Found',
                  colSpan: 6,
                  bold: true,
                  alignment: 'center',
                  fillColor: '#737b84',
                  color: '#f7f9f9',
                },
                {},{},{},{},{}
              ],
              [
                {text:'Code',bold:true},
                {text:'Defect Description',bold:true},
                {text:'Photo',bold:true},
                {text:'Critical',bold:true},
                {text:'Major',bold:true},
                {text:'Minor',bold:true}
              ],
              ...this.defectInfo.map((obj) => {
                return [{text:obj?.defect_code},{text:obj?.defect_description},{text: obj?.Photo},{text: obj?.Critical},{text: obj?.Major},{text: obj?.Minor}];
              }),
              [
                {text:'Total Defects', alignment:'right', colSpan:3},
                {},{},
                {text:this.defectsCount.critical},
                {text:this.defectsCount.major},
                {text:this.defectsCount.minor}
              ]
            ]
          }
        },
        { text: '', style: 'sectionHeader' },
        {
          style: 'tableExample',
          table: {
            widths: [68, 'auto', 'auto','auto','auto','auto','auto','auto','auto','auto'],
            headerColumns:1,
            body: [
              [
                { text: 'Total number in Defect Categories', bold: true, rowSpan: 2 },
                { text: 'A -Fabric', bold: true },
                { text: "B- Construction", bold: true },
                { text: 'C -Component', bold: true },
                { text: 'D-Embellishment', bold: true },
                { text: 'E- Finishing', bold: true },
                { text: 'F- Measurement', bold: true },
                { text: 'G- Labelling', bold: true },
                { text: 'H- Metal Contamination', bold: true },
                { text: 'I -Infestation', bold: true }
              ],
              [
                '',
                {text:this.inspectionData?.Total_A},
                {text:this.inspectionData?.Total_B},
                {text:this.inspectionData?.Total_C},
                {text:this.inspectionData?.Total_D},
                {text:this.inspectionData?.Total_E},
                {text:this.inspectionData?.Total_F},
                {text:this.inspectionData?.Total_G},
                {text:this.inspectionData?.Total_H},
                {text:this.inspectionData?.Total_I}
              ]
            ]
          }
        },
        { text: '', style: 'sectionHeader' },
        {
          style: 'tableExample',
          table: {
            widths: ['auto',50,'auto',50,'auto',50,90,90],
            body: [
              [
                { text: 'Inspection Results -', bold: true },
                {},
                { text: 'PASS', bold: true },
                { text: this.inspectionData?.PASS},
                { text: 'FAIL', bold: true },
                { text: this.inspectionData?.FAIL},
                { text: '', colSpan: 2 },
                {}
              ],
              [
                {
                  text:'Quantity of garments removed (with major defects) if inspection passes:',
                  colSpan: 5,
                  bold: true,
                },
                {},{},{},{},
                { text: this.inspectionData?.removed_quantity },
                {
                  text: 'Remember only remove OOT if it is over -/+2cm',
                  colSpan: 2,
                  bold: true,
                },
                {}
              ],
              [
                { text: 'Consol. Centre:', bold: true },
                { text: this.inspectionData?.consol_centre, colSpan: 2 },
                {},
                { text: 'Inspector:', bold: true },
                { text: this.inspectionData?.inspector, colSpan: 2 },
                {},
                { text: 'Date:', bold: true },
                { text: moment(this.inspectionData?.inspection_date).format('DD MMM YYYY') }
              ]
            ]
          }
        },
        { text: '', style: 'sectionHeader' },
        this.pdfDefectPhotos,
        this.fullProductImage
      ],
      footer: (page) =>{
        if (page != 1 && page<=this.defectImages.length+1 && this.defectImages?.length>0) {
          return {
            style: 'footer',
            table: {
              widths: ['auto', 300, 'auto', 100],
              body: [
                [
                  { text:'', colSpan: 4, style: 'myCell' },{},{},{}
                ],
                [
                  { text: 'Defect', bold: true },
                  { text: this.defectImages[page - 2]?.defect_description },
                  { text: 'Severity', bold: true },
                  { text: this.defectImages[page - 2]?.severity }
                ],
              ]
            }
          }
        }
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 10,
          margin: [0, 5,0, 5] ,
          fillcolor: '#444',
          alignment: 'center',
        },
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        tableExample: {
          margin: [0, 0, 0, 0],
          width: '100%',
          fontSize: 6,
          alighnment: 'center'
        },
        defectTable:{
          margin: [0, 0, 0, 0],
          width: '100%',
          fontSize: 5,
          alighnment: 'center',
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        },
        footer: {
          margin: [40, 0, 40, 0],
          width: '100%',
          fontSize: 6,
          alighnment: 'center'
        },
        myCell: { fillColor: 'grey' },
        link: { color: '#0645AD', decoration: 'underline' },
        defectTitle: {
          fillColor: '#737b84',
          bold: true,
          color: 'white',
        }
      },
    };

    try {
      this.pdf = pdfMake.createPdf(this.docDefinition);
      if (action === 'download') {
        Swal.close();
        this.pdf.download(`Inspection Report ${this.inspectionData?.style_code} ${this.inspectionData?.UDC_id} ${this.inspectionData?.colour_code} ${this.inspectionData?.colour} ${this.inspectionData?.Season}(${this.inspectionData?.inspection_date?.replaceAll('-','.')})`);
      } else if (action === 'print') {
        Swal.close();
        this.pdf.print();
      } else {
        Swal.close();
        this.pdf.open();
      }
    } catch(error) {
      console.log(error);
      this.alertService.errorToast('Failed to Load Report');
      Swal.close();
    }
  }

  getRotatedBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.rotate(90 * Math.PI / 180);
        ctx.translate(0, -canvas.width);
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png",100);
        resolve(dataURL);
      };
      img.onerror = error => {
        Swal.close();
        reject(error);
      };
      img.src = url;
    });
  }

  getBase64ImageFromURL = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve,reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      }
      // reader.onerror = error => {
      //   Swal.close();
      //   console.log("myerror")
      //   reject(error);
      // };
    });
  }

 writeRotatedText = text => {
    let ctx, canvas = document.createElement('canvas');
    canvas.width = 50;
    canvas.height = 150;
    ctx = canvas.getContext('2d');
    ctx.font = '10pt Arial';
    ctx.save();
    ctx.translate(10, 120);
    ctx.rotate(-0.5 * Math.PI);
    ctx.fillStyle = '#000';
    ctx.fillText(text, 0, 0);
    ctx.restore();
    return canvas.toDataURL();
  };

  splitToChunks(array, parts) {
    let result = [];
    // let maxRows=Math.ceil(array.length / parts);
    // for (let i = parts; i > 0; i--) {
        // result.push(array.splice(0, maxRows));
    // }
    result.push(array.splice(0,26));
    result.push(array.splice(0,26));
    result.push(array.splice(0,array?.length));

    return result;
  }

  async downloadImage(url, type, code?) {
    const a: any = document.createElement('a');
    a.href = await this.toDataURL(url);
    // if(type=='fp'){
    // a.download = `${this.inspectionData?.style_code}  Full Product ${this.inspectionData?.UDC_id} ${this.inspectionData?.colour_code} ${this.inspectionData?.colour} ${this.inspectionData?.Season}(${this.inspectionData?.inspection_date.replace('-','.')})`;
    // } else {
    //   a.download = `${this.inspectionData?.style_code} ${this.inspectionData?.UDC_id} ${code} ${this.inspectionData?.colour_code} ${this.inspectionData?.colour} ${this.inspectionData?.Season}(${this.inspectionData?.inspection_date.replace('-','.')})`;
    // }
    a.download = url.substring(url.lastIndexOf('/')+1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  toDataURL(url) {
    return fetch(url).then((response) => {
      return response.blob();
    }).then(blob => {
      return URL.createObjectURL(blob);
    }).catch(err=>{
      Swal.close();
    });
  }
}
